import { useWalmartDisabledPage } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';
import { WalmartLocation } from 'pages/loyalty/loyalty-partners/walmart/walmart-location';

export default function WalmartLocationPage() {
  const disabledRedirect = useWalmartDisabledPage();
  if (disabledRedirect) {
    return disabledRedirect;
  }
  return <WalmartLocation />;
}
